import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import additionalInformationService from '../../../../../services/Internal/Credential/additionalInformation.service';
import AdditionalEngineeringInformationForm from './AdditionalEngineeringInformationForm';
import AdditionalSurveyorInformationForm from './AdditionalSurveyorInformationForm';

function AdditionalInformationPage({ entityId, activeKey, setTabBoldness }) {
    function hasNoInformation(obj, excludeKeys = []) {
        return Object.entries(obj).every(([key, value]) => {
            // Skip excluded properties
            if (excludeKeys.includes(key)) return true;
            // Check for null or undefined
            return value == null || value == undefined;
        });
    }
    const [activeSection, setActiveSection] = useState('engineer')
    const [updateBoldness, setUpdateBoldness] = useState(0);
    const checkForInformation = () => {
        additionalInformationService.getEngineeringAdditionalInfo(entityId).then((response) => {
            if (response.data) {
                let excludedProps = ["dateCrte", "userCrte", "id", "deleted", "entityId"];
                let bold = !hasNoInformation(response.data, excludedProps);
                setTabBoldness(bold);
                if (!bold) {
                    additionalInformationService.getSurveyingAdditionalInfo(entityId).then((surveyResponse) => {
                        if (surveyResponse.data) {
                            bold = !hasNoInformation(surveyResponse.data, excludedProps);
                            setTabBoldness(bold);
                        }
                    })
                }
            }
        })
    }
    useEffect(() => {
        checkForInformation();
    }, [])
    useEffect(() => {
        checkForInformation();
    }, [updateBoldness])
    return (
        <Tabs activeKey={activeSection} transition={false} onSelect={(selected) => { setActiveSection(selected) }}>
            <Tab eventKey="engineer" title="EI/PE">
                <br />
                <AdditionalEngineeringInformationForm entityId={entityId} active={activeSection == 'engineer'} setUpdateBoldness={setUpdateBoldness} updateBoldness={updateBoldness} />
            </Tab>
            <Tab eventKey="surveyor" title="LSI/PLS">
                <br />
                <AdditionalSurveyorInformationForm entityId={entityId} active={activeSection == 'surveyor'} setUpdateBoldness={setUpdateBoldness} updateBoldness={updateBoldness}/>
            </Tab>
        </Tabs>
    );
}
export default AdditionalInformationPage;